import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import Button from './bootstrap/Button';
import Icon from './icon/Icon';
import moment from 'moment';

function ImageVisualisation({ selectedImage, setSelectedImage }) {
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [startPos, setStartPos] = useState({ x: 0, y: 0 });
    console.log("4selectedImage4", selectedImage)
    const fileUrl = selectedImage?.path ? `/coreService/${selectedImage.path}` : selectedImage?.url || '';
    const fileName = selectedImage?.originalName || selectedImage?.fileName || selectedImage?._id || 'fichier';
    const getFallbackType = (name) => {
        if (!name) return 'image';
        const parts = name.split('.');
        return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : 'image';
    };

    const fileType = selectedImage?.mimeType || selectedImage?.type || getFallbackType(fileName);
    // RESET DES ÉTATS
    const closeModal = () => {
        setSelectedImage(null);
        setScale(1);
        setPosition({ x: 0, y: 0 });
    };

    // LOGIQUE DRAG (IMAGE SEULEMENT)
    const handleMouseDown = (e) => {
        if (scale > 1) {
            setIsDragging(true);
            setStartPos({ x: e.clientX - position.x, y: e.clientY - position.y });
        }
    };
    const handleMouseMove = (e) => {
        if (!isDragging) return;
        setPosition({ x: e.clientX - startPos.x, y: e.clientY - startPos.y });
    };
    const handleMouseUp = () => setIsDragging(false);

    // LOGIQUE TÉLÉCHARGEMENT
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // RENDU DU CONTENU SELON LE TYPE
    const renderContent = () => {
        if (!fileUrl) return null;

        // --- 1. IMAGES ---
        if (/image|jpeg|jpg|png|ico/i.test(fileType)) {
            return (
                <img
                    src={fileUrl}
                    alt="Zoom"
                    onMouseDown={handleMouseDown}
                    draggable="false"
                    style={{
                        transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                        transition: isDragging ? 'none' : 'transform 0.1s ease-out',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        userSelect: 'none'
                    }}
                />
            );
        }

        // --- 2. VIDÉOS ---
        else if (
            fileType === 'video' ||
            fileType === 'mp4' ||
            fileType?.toLowerCase() === 'mov' ||
            fileType?.toLowerCase() === 'mkv'
        ) {
            return (
                <video
                    src={fileUrl}
                    controls
                    className="w-100 h-100"
                    style={{ maxHeight: '100%', outline: 'none' }}
                />
            );
        }

        // --- 3. PDF ---
        else if (
            fileType === 'application' ||
            fileType === 'application/pdf' ||
            fileType === 'pdf'
        ) {
            return (
                <iframe
                    src={`${fileUrl}#view=FitH`}
                    title="PDF Viewer"
                    width="100%"
                    height="100%"
                    className="bg-white"
                />
            );
        }

        // --- 4. AUTRES ---
        else {
            return (
                <div className="text-white text-center">
                    <i className="fas fa-file-alt fa-4x mb-3 opacity-50"></i>
                    <p>Aperçu non disponible pour ce type de fichier.</p>
                </div>
            );
        }
    };

    return (
        <Modal show={!!selectedImage} onHide={closeModal} centered size="lg">
            <Modal.Header closeButton className="bg-white">
                <Modal.Title className="fs-6 fw-bold text-truncate">{fileName}</Modal.Title>
            </Modal.Header>
            <Modal.Body
                className="p-0 overflow-hidden bg-dark d-flex align-items-center justify-content-center position-relative"
                style={{
                    height: '75vh',
                    cursor: scale > 1 && /image/i.test(fileType) ? (isDragging ? 'grabbing' : 'grab') : 'default'
                }}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseUp}
            >
                {/* BARRE DE CONTRÔLES */}
                <div className="position-absolute bottom-0 mb-3 text-center" style={{ zIndex: 10 }}>
                    <div className="btn-group shadow mb-2">
                        <Button color="light" onClick={() => { setScale(s => Math.max(s - 0.5, 1)); setPosition({ x: 0, y: 0 }); }}> - </Button>
                        <Button color="light" onClick={() => { setScale(s => Math.min(s + 0.5, 5)) }}> +</Button>
                    </div>

                    <div className="d-block">
                        <Button color="primary" onClick={handleDownload} className="rounded-pill px-4 shadow">
                            Télécharger
                        </Button>
                    </div>
                </div>

                {renderContent()}
            </Modal.Body>
        </Modal>
    );
}

export default ImageVisualisation